import './src/index';
import './scripts/global';
import { defineCustomElements } from './dist/stencil/esm/loader';

defineCustomElements();

import './dist/hydration.css';
import './dist/stencil/pmi/pmi.css';
import './src/global/external/flags.css';
import './src/global/fonts-local.css';
